import { dataInprogress } from '../Data';
import { Card, CardImag, CardText, Content, Heading, Image, TextDiscretion, TextProgress } from '../StyledSystemManagementLearn'
import { Circle } from '../../../../images';
import { ProgressLine } from '../../../../Components/Form';
const NotActive = () => {
    return (
        <>
            <Content>
                {
                    dataInprogress.map((card) => (
                        <Card key={card.id} >
                            <CardImag>
                                <Image src={card.img} alt={card.name} />
                            </CardImag>
                            <CardText>
                                <Heading>
                                    {card.name}
                                </Heading>
                                <TextDiscretion>
                                    {card.discretion}<img src={Circle} style={{ margin: '5px 7px' }} alt="circle" /> {card.date}
                                </TextDiscretion>
                                <ProgressLine value={card.progress} backgroundactive='#828282' />
                                <TextProgress>
                                    {card.progress}%  تقدم منذ حوالي شهر 
                                </TextProgress>
                            </CardText>
                        </Card>
                    )).slice(0, 3)
                }
            </Content>
        </>

    )
}

export default NotActive